import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Area } from '../models/area';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AreaService {
  private areaRoute = 'items/area';

  allAreas: Area[];
  activeAreas: Area[];
  // Observable triggered when regions
  activeAreasObservable: Subject<Area[]>;

  constructor(private http: HttpClient) {
    this.activeAreasObservable = new Subject<Area[]>();
  }

  getAll = () =>
    this.http
      .get(`${environment.directusBaseUrl}items/area` + '?fields=*.*&status=published')
      .toPromise()
      .then((result: { data: Area[] }) => result.data);

  async getActiveSubRegions() {
    const data = await this.http
      .get<{ data: Area[] }>(
        `${environment.directusBaseUrl}items/area` + '?filter[status]=published&' + 'fields=*.*',
      )
      .toPromise();
    return data.data;
  }

  async getHierarchy(childAreaId: string) {
    const fields = 'id,parent.id,parent.parent.id,parent.parent.parent.id';
    const url = new URL(`${environment.directusBaseUrl}${this.areaRoute}/${childAreaId}`);
    url.searchParams.set('fields', fields);
    const response = await this.http.get<{ data: Area[] }>(url.href).toPromise();
    const areas = response.data;
    return areas;
  }

  // Trigger this when area slug is detected
  initActiveAreas = (startAreaSlug: string) => {
    // return new Promise((resolve, reject) => {
    if (this.allAreas) {
      this.activeAreas = this.parseActiveAreas(startAreaSlug);
    } else {
      this.getAll().then((area) => {
        this.allAreas = area;
        this.activeAreas = this.parseActiveAreas(startAreaSlug);
        this.activeAreasObservable.next(this.activeAreas);
      });
    }
    // });
  };

  parseActiveAreas = (parentSlug: string) => {
    const active = this.allAreas.filter((area) => {
      if (!area.parent) {
        return false;
      } else {
        return area.parent.id === parentSlug;
      }
    });
    const parentId = this.allAreas.find((geo) => geo.id === parentSlug);
    if (parentId) {
      active.unshift(parentId);
    }
    return active;
  };
}
